import * as React from 'react'
import Image from '@components/Image'
import { getLayoutConfig } from '../config'

export const Logo = () => {
  const config = getLayoutConfig()

  const isSvgLogo = config.logo.toLowerCase().endsWith('.svg')

  if (!isSvgLogo) {
    return (
      <Image
        alt={config.copyright}
        height={config.logoHeight}
        src={config.logo}
        width={config.logoWidth}
      />
    )
  }

  return (
    <img
      alt={config.copyright}
      className="block w-[var(--logo-w)] h-[var(--logo-h)]"
      decoding="async"
      loading="lazy"
      src={config.logo}
      style={
        {
          '--logo-h': `${config.logoHeight}px`,
          '--logo-w': `${config.logoWidth}px`,
        } as React.CSSProperties
      }
    />
  )
}
